import React, { Component } from 'react'
import config from 'config'
import Logo from 'components/Logo'
import hamburgerSvg from './hamburger.svg'
import MobileHeaderMenu from '../MobileHeaderMenu'
import ConditionalRender from 'components/ConditionalRender'
import { redirectToLoginPage } from '@driftt/web-auth'

import './style.css'


class Header extends Component {

  state = {
    isMobileMenuOpen: false
  }

  openMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
    console.log(this.state)
  }

  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  redirectToLogin = () => {
    redirectToLoginPage(config.AUTH_CLIENT_ID)
  }

  render() {
    const { isMobileMenuOpen } = this.state

    return (
      <div className="home-header-menu">
        <Logo
          color="white"
          className="home-header-menu-logo"
        />
        <img
          className="home-header-menu-hamburger"
          src={hamburgerSvg}
          alt="menu"
          onClick={this.openMobileMenu}
        />
        <div className="home-header-menu-links">
          <a href="https://community.drift.com/categories/developer">Community</a>
          <a href="https://www.drift.com">Drift.com</a>
          <a href="https://devdocs.drift.com">Docs</a>
          <button
            onClick={this.redirectToLogin}
            className="home-header-menu-links-login">
            Sign In
          </button>
        </div>

        <ConditionalRender condition={isMobileMenuOpen}>
          <MobileHeaderMenu onCloseInitiated={this.closeMobileMenu} />
        </ConditionalRender>
      </div>
    )
  }
}

export default Header
